export const userFullName = (firstName:string = null, lastName: string = null) => {
  const fName = firstName ? firstName.toString().trim() : ''
  const lName = lastName ? lastName.toString().trim() : ''
  const spacing = fName.length > 0 && lName.length > 0 ? ' ' : ''
  return `${fName}${spacing}${lName}`
}
